import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface CreditCardProps {
  transaction: any;
  paymentAmount: string;
  onPaymentAmountChange: (value: string) => void;
  onPayment: () => void;
}

export const CreditCard = ({
  transaction,
  paymentAmount,
  onPaymentAmountChange,
  onPayment,
}: CreditCardProps) => {
  return (
    <Card className="p-4">
      <div className="space-y-2">
        <div className="font-medium">
          {transaction.stock_items?.data?.name || "Produit non spécifié"}
        </div>
        <div className="text-sm text-gray-500">
          Montant total: {transaction.total_amount.toLocaleString()} FCFA
        </div>
        <div className="text-sm text-gray-500">
          Reste à payer: {transaction.remaining_amount.toLocaleString()} FCFA
        </div>
        <div className="text-sm text-gray-500">
          Date: {format(new Date(transaction.created_at), "PPP", { locale: fr })}
        </div>
        <div className="mt-4 space-y-2">
          <Input
            type="number"
            placeholder="Montant du paiement"
            value={paymentAmount}
            onChange={(e) => onPaymentAmountChange(e.target.value)}
          />
          <Button onClick={onPayment} className="w-full">
            Payer
          </Button>
        </div>
      </div>
    </Card>
  );
};